import type { Glyphs } from "@edreamsodigeo/prisma-design-system/esm/iconography/Glyph/generated.types";

import type { BENEFIT_TRACKING } from "~/components/acquisition/Lightbox/LightboxRevamp/config/tracking";

enum Plan {
  Prime = "Prime",
  PrimePlus = "PrimePlus",
}

enum Perk {
  FreeCancellation = "FreeCancellation",
  FreeCancellationFreeTrial = "FreeCancellationFreeTrial",
}

interface LightboxBenefit {
  key: BENEFIT_TRACKING;
  title: string;
  description: string;
  iconCategory: keyof Glyphs;
  icon: Glyphs[keyof Glyphs];
  plan: Plan;
  category: string;
  perk?: Perk;
  appOnly?: boolean;
  termsAndConditions?: string;
  termsAndConditionsLink?: string;
}

interface LightboxBenefits {
  benefits: LightboxBenefit[];
}

interface LightboxRevampData {
  data?: LightboxBenefits;
}

export { Plan, Perk, LightboxBenefit, LightboxBenefits, LightboxRevampData };
